import type { Strings } from './strings.js';

export const nl: Strings = {
  languageName: 'Nederlands',
  welcome: 'Welkom',
  chooseReason: 'Waarmee kunnen wij u helpen?',
  back: 'Terug',
  cancel: 'Annuleren',
  next: 'Verder',
  submit: 'Versturen',
  submitting: 'Wordt verstuurd',
  yourDetails: 'Uw gegevens',
  optional: 'optioneel',
  required: 'verplicht',
  requiredHint: 'Vul de gemarkeerde velden in.',
  fieldRequired: 'Vul dit veld in.',
  fieldInvalid: 'Controleer deze gegevens.',
  pleaseSelect: 'Maak een keuze',
  search: 'Zoeken',
  noResults: 'Geen resultaat',
  noOptions: 'Er is hier op dit moment niets te kiezen. Vraag een medewerker om hulp.',
  stepReason: 'Reden',
  stepDetails: 'Gegevens',
  stepDone: 'Klaar',
  thankYou: 'Hartelijk dank!',
  submitted: 'Uw aanmelding is verstuurd.',
  waitHint: 'Neem plaats. U wordt zo opgeroepen.',
  scanFormHint: 'Scan de code met uw telefoon om het formulier mee te nemen.',
  ticketNumber: 'Uw wachtnummer is',
  queuedTitle: 'Hartelijk dank!',
  queuedHint: 'Uw aanmelding is opgeslagen en wordt automatisch verstuurd. Neemt u alstublieft plaats.',
  errorTitle: 'Dit is helaas niet gelukt',
  errorHint: 'Probeer het opnieuw of vraag een medewerker om hulp.',
  tryAgain: 'Opnieuw proberen',
  startOver: 'Opnieuw beginnen',
  closedTitle: 'Ons kantoor is op dit moment gesloten',
  closedHint: 'U kunt zich toch aanmelden - wij nemen op de eerstvolgende werkdag contact met u op.',
  closedCallUs: 'Telefonisch bereikbaar op',
  continueAnyway: 'Toch aanmelden',
  appointmentQuestion: 'Heeft u een afspraak?',
  appointmentYes: 'Ja, ik heb een afspraak',
  appointmentNo: 'Nee, ik heb geen afspraak',
  visitingWhom: 'Wie komt u bezoeken?',
  privacyTitle: 'Privacy',
  privacyAccept: 'Ik heb de privacyverklaring gelezen.',
  privacyRequired: 'Bevestig de privacyverklaring.',
  offline: 'Offline',
  offlineHint: 'Geen verbinding - aanmeldingen worden opgeslagen en later verstuurd.',
  pendingCount: 'opgeslagen aanmelding(en)',
  idleWarning: 'Uw invoer wordt zo gewist.',
  pairTitle: 'Tablet verbinden',
  pairHint: 'Voer de koppelcode uit de administratie in.',
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'Verbinden',
  pairError: 'De code is ongeldig of verlopen.',
  pairSuccess: 'Tablet verbonden',
  loading: 'Laden',
  notConfigured: 'Geen bezoektypes ingesteld',
  notConfiguredHint: 'Vraag een medewerker om hulp.',
  adminLink: 'Beheer',
  pairCodeHint:
    'De code wordt in de beheeromgeving aangemaakt onder “Locaties en tablets” en is maar beperkte tijd geldig.',
  setupTitle: 'Nog niet ingericht',
  setupText:
    'Dit systeem is nog niet ingericht. De installatiewizard maakt de beheerder, de organisatie, een locatie en de eerste tablet aan.',
  setupButton: 'Inrichting starten',
  setupAfter: 'Daarna verschijnt hier automatisch het veld voor de koppelcode.',
};
